export default __webpack_public_path__ + "logo-2.png";